export const content = {
  title:'Estatus Beneficiario',
  nodata:'Sin Registro',
  error:'Sin registro',
  button:'Guardar',
  cancelButton:'Cancelar',
  image_button:'Cambiar',
  form:{
    status_id:{
      label:'Estatus Beneficiario',
      placeholder:'Seleccione una opción',
    },
    inactive_reason_id:{
      label:'Motivo',
      placeholder:'Seleccione una opción',
    },
  },
}